import { createFileRoute } from "@tanstack/react-router"
import Orders from "@/pages/account/orders"

export const Route = createFileRoute("/$countryCode/account/orders/")({
  head: () => ({
    meta: [
      { title: "Order history | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Orders,
})
